import React from 'react';
import implementationImage from '../../../../../../Assets/InforPage/serviceOfferings/Implementation.jpg';
import cloudImage from '../../../../../../Assets/InforPage/serviceOfferings/migrateCloud.jpg';
import integrationImage from '../../../../../../Assets/InforPage/InforOs.jpg';
import customizationImage from '../../../../../../Assets/InforPage/serviceOfferings/customization.jpg';
import optimizationImage from '../../../../../../Assets/InforPage/process-improvement.png';
import supportImage from '../../../../../../Assets/InforPage/Training.jpg';

const services = [
  {
    title: 'Implementation',
    image: implementationImage,
  },
  {
    title: 'Cloud & Upgrades',
    image: cloudImage,
  },
  {
    title: 'Integration',
    image: integrationImage,
  },
  {
    title: 'Customization',
    image: customizationImage,
  },
  {
    title: 'Optimization',
    image: optimizationImage,
  },
  {
    title: 'Support & Training',
    image: supportImage,
  },
];

const ServiceCard = ({ title, image }) => (
  <article
    className="relative flex min-h-[270px] items-end overflow-hidden rounded-2xl border p-6 sm:min-h-[290px]"
    style={{
      backgroundImage: `linear-gradient(180deg, rgba(7, 20, 31, 0.12) 0%, rgba(7, 20, 31, 0.78) 100%), url(${image})`,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      borderColor: 'rgba(255,255,255,0.28)',
      boxShadow: '0 12px 28px rgba(10, 25, 37, 0.1)',
    }}
  >
    <h3 className="relative z-10 text-xl font-semibold tracking-tight sm:text-2xl" style={{ color: '#FFFFFF' }}>
      {title}
    </h3>
  </article>
);

const LNOverview = () => (
  <section id="ln-overview" className="px-4 py-14 sm:px-6 lg:px-8 lg:py-20" style={{ backgroundColor: '#FFFFFF' }}>
    <div className="mx-auto max-w-7xl">
      <div className="mb-9 flex flex-col justify-between gap-5 sm:flex-row sm:items-end">
        <div>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em]" style={{ color: '#276C7B' }}>Infor LN services</p>
          <h2 className="text-2xl font-bold tracking-tight sm:text-3xl md:text-4xl" style={{ color: '#1A2634' }}>
            Support for every stage of your ERP journey
          </h2>
        </div>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((service) => (
          <ServiceCard key={service.title} {...service} />
        ))}
      </div>
    </div>
  </section>
);

export default LNOverview;
